<template>
  <div>
    <base-card :option="cardOption">
      <div slot="cardBody">
        <a-tabs :activeKey="activeKey" @change="callback">
          <a-tab-pane key="1" tab="销售合同" forceRender>
            <sales-contract ref="salesContract"></sales-contract>
          </a-tab-pane>
          <a-tab-pane key="2" tab="采购合同" forceRender>
            <purchase-contract ref="purchaseContract"></purchase-contract>
          </a-tab-pane>
        </a-tabs>
      </div>
    </base-card>
  </div>
</template>

<script>
import salesContract from './sales/List'
import purchaseContract from './purchase/List'
import baseCard from '@/CrComponents/Card/Card'
export default {
  components: {
    salesContract,
    purchaseContract,
    baseCard
  },
  data () {
    return {
      // card相关属性设置
      cardOption: {},

      activeKey: '1'
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    initData () {
      // 初始化项目列表
      this.$store.dispatch('handleProjectList')
      // 初始化业主信息
      this.$store.dispatch('handleProprietorList')
      // 初始化供应商列表
      this.$store.dispatch('handleSupplierList')
      // 初始化人员列表
      this.$store.dispatch('handleUserList')
    },
    callback (activeKey) {
      this.activeKey = activeKey
    }
  }
}
</script>
